import React from 'react';

import LiveClassVimeoComponent from './LiveClassVimeoComponent';
import LiveClassBunnyComponent from './LiveClassBunnyComponent';
import { LiveClassVideoPlayerProps, usesNativePlayer } from './videoProvider';

const LiveClassVideoPlayer: React.FC<LiveClassVideoPlayerProps> = (props) =>
  usesNativePlayer(props.url) ? (
    <LiveClassBunnyComponent {...props} />
  ) : (
    <LiveClassVimeoComponent {...props} />
  );

export default LiveClassVideoPlayer;
